import { EventData, VdpEventData } from 'lib/EventLogger/Event';
import { EventType, SourcePages, ViewTypes } from 'lib/EventSchema';

export function SrpPageViewEvent(sourceUrl?: string): EventData & VdpEventData {
  const eventData = {
    event_type: EventType.view,
    source_page: SourcePages.Srp,
    view_type: ViewTypes.pageView,
  } as EventData;

  if (sourceUrl) eventData.event_context = { url: sourceUrl };

  return eventData;
}

export function SeoSrpPageViewEvent(sourceUrl?: string): EventData & VdpEventData {
  const eventData = {
    event_type: EventType.view,
    source_page: SourcePages.SeoSrp,
    view_type: ViewTypes.pageView,
  } as EventData;

  if (sourceUrl) eventData.event_context = { url: sourceUrl };

  return eventData;
}
